import React from "react";
import ReactDOM from "react-dom";
import LoginComponent from "../../Common/LoginComponent/LoginComponent";
import "./login-portal.style.scss";
export default function LoginPortal({ closeIt, openSignUp }) {
  const [fpModal, setFPModal] = React.useState(false);
  return ReactDOM.createPortal(
    <div
      style={fpModal ? { opacity: 0 } : {}}
      onClick={() => closeIt()}
      className="login-portal-main"
    >
      <div onClick={(e) => e.stopPropagation()} className="login-modal-wrapper">
        <button onClick={() => closeIt()} className="close-button">
          x
        </button>
        <LoginComponent
          setFPModal={setFPModal}
          openSignUp={openSignUp}
          setMainType={() => {}}
          indirect="candidate"
          modal={true}
          modalClose={closeIt}
        />
      </div>
    </div>,
    document.body
  );
}
